// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__gl_lI","form":"styles_form__ARzr3","header":"styles_header__piN4V","section":"styles_section__O2WYL"};